$(document).ready(function () {
  // Use MutationObserver instead of setInterval for better performance
  const targetSelector = '.kaching-bundles__block .kaching-bundles__bar';
  let processed = false;

  function processElements() {
    if (processed) return;

    var $targetElement = $(targetSelector).eq(1);
    if (!$targetElement.length) return;

    processed = true;

    // Create the Momentum Pack div with SVG and text
    var $newDiv = $('<div>', { class: 'kaching-bundle-momentum' });
    var svgContent = `
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 16 20" fill="none">
        <path d="M9.32172 0.804597C9.23697 0.734135 9.13652 0.685081 9.02884 0.661573C8.92115 0.638064 8.8094 0.640789 8.70299 0.669518C8.59659 0.698247 8.49865 0.752138 8.41743 0.826648C8.33621 0.901157 8.2741 0.994101 8.23633 1.09764L6.3457 6.28913L4.26945 4.27733C4.19973 4.2097 4.11646 4.15762 4.02514 4.12451C3.93382 4.0914 3.83652 4.07802 3.73965 4.08524C3.64279 4.09247 3.54855 4.12014 3.46315 4.16643C3.37776 4.21273 3.30314 4.27659 3.24422 4.35382C1.38281 6.79272 0.4375 9.24624 0.4375 11.6456C0.4375 13.6513 1.23426 15.5749 2.65251 16.9931C4.07075 18.4114 5.9943 19.2081 8 19.2081C10.0057 19.2081 11.9293 18.4114 13.3475 16.9931C14.7657 15.5749 15.5625 13.6513 15.5625 11.6456C15.5625 6.53663 11.1977 2.36436 9.32172 0.804597ZM12.803 12.4483C12.6248 13.444 12.1457 14.3613 11.4303 15.0765C10.7149 15.7917 9.7976 16.2706 8.8018 16.4487C8.76405 16.4551 8.7258 16.4583 8.6875 16.4581C8.51505 16.4581 8.34891 16.3932 8.22203 16.2764C8.09516 16.1596 8.01682 15.9994 8.00254 15.8275C7.98826 15.6557 8.03909 15.4847 8.14496 15.3486C8.25082 15.2124 8.40398 15.1211 8.57406 15.0926C9.99805 14.8528 11.2063 13.6445 11.4478 12.218C11.4784 12.0381 11.5791 11.8778 11.7278 11.7722C11.8766 11.6667 12.0612 11.6245 12.241 11.6551C12.4208 11.6856 12.5812 11.7863 12.6867 11.9351C12.7923 12.0838 12.8344 12.2684 12.8039 12.4483H12.803Z" fill="black"></path>
      </svg>
    `;
    $newDiv.append(svgContent);
    $newDiv.append('<span>Momentum Pack</span>');
    $targetElement.append($newDiv);

    // Subtitle container list
    var $subtitleElements = $('.kaching-bundles__bar-content-left');

    const firstSubtitleReplaceText = $('#js_replace_autoship_subheading_1').val();
    const secondSubtitleReplaceText = $('#js_replace_autoship_subheading_2').val();
    const thirdSubtitleReplaceText = $('#js_replace_autoship_subheading_3').val();

    // First subtitle
    if ($subtitleElements.eq(0).length && $subtitleElements.eq(0).find('.kaching-bundle-subtitle').length === 0) {
      if (firstSubtitleReplaceText) {
        $subtitleElements.eq(0).append('<span class="kaching-bundle-subtitle">' + firstSubtitleReplaceText + '</span>');
      } else {
        $subtitleElements.eq(0).append('<span class="kaching-bundle-subtitle">Easy way to try it and build a daily habit</span>');
      }
    }

    // Second subtitle
    if ($subtitleElements.eq(1).length && $subtitleElements.eq(1).find('.kaching-bundle-subtitle').length === 0) {
      if (secondSubtitleReplaceText) {
        $subtitleElements.eq(1).append('<span class="kaching-bundle-subtitle">' + secondSubtitleReplaceText + '</span>');
      } else {
        $subtitleElements.eq(1).append('<span class="kaching-bundle-subtitle">Stack steady wins for 90 days</span>');
      }
    }

    // Third subtitle
    if ($subtitleElements.eq(2).length && $subtitleElements.eq(2).find('.kaching-bundle-subtitle').length === 0) {
      if (thirdSubtitleReplaceText) {
        $subtitleElements.eq(2).append('<span class="kaching-bundle-subtitle">' + thirdSubtitleReplaceText + '</span>');
      } else {
        $subtitleElements.eq(2).append('<span class="kaching-bundle-subtitle">Biggest value. Longest run. Zero gaps</span>');
      }
    }

    var $subtitlelement = $('.kaching-bundles__bar-wrapper');

    if ($subtitlelement.eq(0).length && $subtitlelement.eq(0).find('.kaching-bundle-subtitle-mobile').length === 0) {
      if (firstSubtitleReplaceText) {
        $subtitlelement.eq(0).append('<span class="kaching-bundle-subtitle-mobile">' + firstSubtitleReplaceText + '</span>');
      } else {
        $subtitlelement.eq(0).append('<span class="kaching-bundle-subtitle-mobile">Easy way to try it and build a daily habit</span>');
      }
    }

    if ($subtitlelement.eq(1).length && $subtitlelement.eq(1).find('.kaching-bundle-subtitle-mobile').length === 0) {
      if (secondSubtitleReplaceText) {
        $subtitlelement.eq(1).append('<span class="kaching-bundle-subtitle-mobile">' + secondSubtitleReplaceText + '</span>');
      } else {
        $subtitlelement.eq(1).append('<span class="kaching-bundle-subtitle-mobile">Stack steady wins for 90 days</span>');
      }
    }

    if ($subtitlelement.eq(2).length && $subtitlelement.eq(2).find('.kaching-bundle-subtitle-mobile').length === 0) {
      if (thirdSubtitleReplaceText) {
        $subtitlelement.eq(2).append('<span class="kaching-bundle-subtitle-mobile">' + thirdSubtitleReplaceText + '</span>');
      } else {
        $subtitlelement.eq(2).append('<span class="kaching-bundle-subtitle-mobile">Biggest value. Longest run. Zero gaps</span>');
      }
    }

    $('.kaching-bundles__free-gift__full-price').each(function () {
      if (!$(this).find('.kaching-bundle-free').length) {
        $(this).append('<span class="kaching-bundle-free">FREE</span>');
      }
    });

    $('.kaching-bundles__bar-pricing').each(function (index) {
      var $pricing = $(this);
      var $savePercentage = $('.custom-kaching-save-percentage').eq(index);

      if ($savePercentage.length && $pricing.find('.save-percentage-display').length === 0) {
        var saveText = $savePercentage.text().trim();
        var $saveSpan = $('<div>', {
          class: 'save-percentage-display',
          text: saveText
        });
        $pricing.append($saveSpan);
      }
    });

    console.log('All elements appended successfully');
  }

  // Try immediately
  processElements();

  // Use MutationObserver for better performance
  const observer = new MutationObserver(function () {
    processElements();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Fallback timeout (clear observer after 10 seconds)
  setTimeout(function () {
    observer.disconnect();
  }, 10000);
});
